
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/wm-account-payable-operations",
      function () {
        return require("private-next-pages/solutions/wm-account-payable-operations/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/wm-account-payable-operations"])
      });
    }
  